// src/components/PostDetail/index.js

import React from "react";
import { Link } from "react-router-dom";
import "../PostList/style.css";

function PostDetail() {
    return (
        <div className="blog-container">
            <header>
                <h1>Gideon's Blog</h1>
            </header>
            
            <section className="content">
                <p>As of late April 2025, I am in the process of migrating my blog archive here. Expect it by mid-May.</p>
            </section>
            
            <div className="nav">
                <Link to="/blog">← Back to Blog</Link>
                <Link to="/" style={{marginLeft: "20px"}}>← Back to Home</Link>
            </div>
        </div>
    );
}

export default PostDetail;